module.exports = __webpack_public_path__ + "img/your-guide-to-xrp.6c4e240e.png";